import { render, staticRenderFns } from "./RightTabs.vue?vue&type=template&id=d8d9d9d0&scoped=true"
import script from "./RightTabs.vue?vue&type=script&lang=js"
export * from "./RightTabs.vue?vue&type=script&lang=js"
import style0 from "./RightTabs.vue?vue&type=style&index=0&id=d8d9d9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d9d9d0",
  null
  
)

export default component.exports